"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=require("./index149.js");var e=n.toString,i=function(t,r){return t===void 0?arguments.length<2?"":r:e(t)};exports.normalizeStringArgument=i;
